import { connect } from 'react-redux'
import component from './component'

function mapStateToProps (state, ownProps) {
  return {
    language: state.accountReducer.language,
    permission: state.accountReducer.permission
  }
}

export default connect(
  (state, ownProps) => mapStateToProps(state, ownProps),
  null
)(component)
